import React from 'react'
import { connect } from 'react-redux'
import * as pt from 'prop-types'
import createReactClass from 'create-react-class'
import deepEqual from 'deep-equal'
import _ from 'underscore'
import Select from 'react-select'

import actions from '../../redux/actions'
import { track, EVENTS } from '../../lib/tracking'
import CategorySelect from '../../embed/hoc/types/CategorySelect'
import { getDefaults } from '../../routes/events/state/events-query'
// require('react-select/dist/react-select.css');
function noop() {}

var params = [
  { displayName: 'Title', apiName: 'title' },
  { displayName: 'Description', apiName: 'description' },
  { displayName: 'Event ID', apiName: 'eventID' },
  { displayName: 'Custom ID', apiName: 'customID' },
  // { displayName: 'Category', apiName: 'category' },
  { displayName: 'Keyword', apiName: 'keywords' },
  { displayName: 'Categories', apiName: 'anyCategories' },
]

var Search = createReactClass({
  propTypes: {
    onSearch: pt.func.isRequired,
    disabled: pt.bool,
    categories: pt.array,
    keywords: pt.array,
    onParamSelect: pt.func,
    showCategories: pt.bool,
    showKeywords: pt.bool,
  },

  getDefaultProps: function () {
    return {
      onParamSelect: noop,
      showCategories: true,
      showKeywords: true,
    }
  },

  getInitialState: function () {
    return {
      parameter: {
        displayName: null,
        apiName: null,
      },
      value: '',
    }
  },

  componentWillMount: function () {
    if (this.props.searchParameter) {
      this.setState({
        parameter: {
          displayName: this.props.searchParameter.displayName,
          apiName: this.props.searchParameter.apiName,
        },
        value: this.props.searchParameter.value,
      })
    }
  },
  componentDidUpdate: function (prevProps, prevState) {
    if (this.props.searchParameter === null && prevProps.searchParameter && (this.state.parameter.displayName || this.state.value)) {
      this.setState({
        parameter: {
          displayName: null,
          apiName: null,
        },
        value: '',
      })
    }
  },

  handleParamSelect: function (param, ev) {
    ev.preventDefault()
    this.setState({
      parameter: param,
    })
    this.props.onParamSelect(param.apiName)
  },

  suggest: function (ev) {
    var param = this.state.parameter.apiName
    if (param !== 'anyCategories' && param !== 'keywords') return
    this.setState({ suggestions: param })
  },

  handleSubmit: function (ev) {
    ev.preventDefault()
    var param = this.state.parameter.apiName
    if (param === 'anyCategories') {
      const query = {}
      query[param] = [...this.state.value].map((categoryName) => {
        const availableCategories = this.props.categories || []
        return availableCategories.find((cat) => {
          return cat.categoryName === categoryName
        }).categoryID
      })
      this.props.setFilter(query)
    } else {
      var value = ev.target.elements.term.value
      var query = {}
      // for categories convert the categoryName into it's id
      query[param] = value
      this.props.setFilter(query)
    }
    track(EVENTS.EVENTS_SEARCH, { param: param || null, has_query: Boolean(param) })
    this.props.requestEvents()
  },

  handleChange: function (ev) {
    this.setState({ value: ev ? ev.value : null })
  },

  setValue: function (ev) {
    this.setState({ value: ev.target.value })
  },

  render: function () {
    var param = this.state.parameter

    function parameterLi(param) {
      return (
        <li key={param.apiName}>
          <a href='#' onClick={this.handleParamSelect.bind(this, param)}>
            {param.displayName}
          </a>
        </li>
      )
    }

    function createSelectInput() {
      if (param.apiName !== 'anyCategories') {
        const options = this.props.keywords.map(function (keyword) {
          return { value: keyword.keyword, label: keyword.keyword }
        })
        return (
          <Select
            placeholder='Select Option'
            name='term'
            options={_(options).sortBy('label')}
            onChange={this.handleChange}
            value={this.state.value || []}
          />
        )
      }
      // check that given categories are the categoryName and not the category ids
      let value = []
      if (this.state.value && Array.isArray(this.state.value)) {
        value = [
          ...this.state.value.map((catData) => {
            const availableCategories = this.props.categories || []
            const category = availableCategories.filter((cat) => {
              return cat.categoryID === catData || cat.categoryName === catData
            })[0]
            // return either the mapped or the original if a mapped copy wasn't found
            // this happens if the categories hasn't loaded
            if (category !== undefined) {
              return category.categoryName
            }
            return catData
          }),
        ]
      }
      return (
        <CategorySelect
          storeEdits={(edits) => {
            this.handleChange({ value: edits })
          }}
          value={value}
          clearFull={true}
          useName={false}
          useHidden={false}
        />
      )
    }

    var searchInput =
      param.apiName === 'anyCategories' || param.apiName === 'keywords' ? (
        createSelectInput.call(this)
      ) : (
        <input
          type='text'
          className='form-control'
          name='term'
          placeholder='Search &hellip;'
          onChange={this.setValue}
          value={this.state.value}
          disabled={this.state.parameter.apiName === null || this.props.disabled}
        />
      )

    var style = {
      opacity: this.props.disabled ? '0.4' : 'initial',
    }

    return (
      <div id='event-listing-search' className='clearfix hidden-print' style={style}>
        <div style={{ paddingLeft: 0, width: '100%' }}>
          <form onSubmit={this.handleSubmit}>
            <div className='input-group'>
              <div className='input-group-btn'>
                <div className='btn-group'>
                  <button
                    disabled={this.props.disabled}
                    type='button'
                    className='btn btn-default dropdown-toggle'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'
                  >
                    {this.state.parameter.displayName ? (
                      this.state.parameter.displayName + ' '
                    ) : (
                      <span>
                        <span className='hidden-xs'>Select</span> Option{' '}
                      </span>
                    )}
                    <span className='caret'></span>
                  </button>

                  <ul className='dropdown-menu'>
                    {params.slice(0, 2).map(parameterLi, this)}
                    <li className='divider' />
                    {params.slice(2, 4).map(parameterLi, this)}
                    <li className='divider' />
                    {this.props.showCategories ? parameterLi.call(this, params[4]) : null}
                    {this.props.showKeywords ? parameterLi.call(this, params[5]) : null}
                  </ul>
                </div>
              </div>

              {searchInput}

              <span className='input-group-btn'>
                <button
                  className='btn btn-default'
                  disabled={!this.state.parameter.apiName || this.props.disabled}
                  type='submit'
                >
                  <i className='fa fa-search' />
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    )
  },
})

const mapStateToProps = (state) => {
  const categories = state.data.categories
  let searchParameter = null
  let searchParameterDisplayName = null
  const filters = state.events.filters
  const defaultFilters = getDefaults(state)
  //loop through state filters to find first match in params that can be searched
  // return the value of the filter into searchParameter
  const searchKey = Object.keys(filters).find((key) => {
    const foundParam = params.find((param) => param.apiName === key)
    if (foundParam && !deepEqual(filters[key], defaultFilters[key])) {
      searchParameterDisplayName = foundParam.displayName
      return true
    }
  })
  if (searchKey) {
    searchParameter = {
      displayName: searchParameterDisplayName || null,
      apiName: searchKey || null,
      value: filters[searchKey],
    }
  }
  return { categories, searchParameter }
}

const mapDispatchToProps = (dispatch) => ({
  setFilter: (filters) => dispatch(actions.events.setEventsFilter(filters, true)),
  requestEvents: () => dispatch(actions.data.requestEvents()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)
